import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'
import { getSubLabel } from 'lib/util/string'

const styles = theme => ({
  row: {
    gap: '0.75rem',
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: '0.25rem',
  },
})

/**
 * Displays the part name, articleNumber and comment for a part in the 'add part' list.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
export const ListItemCellCartPartName = (classes, props = {}) => {
  const { label, info1, articleNumberLabel } = props || {}
  const subLabel = getSubLabel(Text, [articleNumberLabel, info1])

  return (
    <Grid
      container
      direction={'row'}
      className={classes.row}
    >
      <Grid
        item
        xs={'auto'}
        alignSelf={'stretch'}
      >
        <Grid
          container
          gap={'0.125rem'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}

          sx={{ height: '100%' }}
        >
          <Text
            maxLines={1}
            value={label}
            variant={'14/bold'}
            color={'black.main'}
          />
          <Grid
            item
            container
            xs={'auto'}
            className={classes.subLabel}
          >
            {subLabel}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellCartPartName, styles)
